<template>
  <div class="LevelSeting">
    <!-- <div class="left">
      <ul>
        <template class="box">
          <li
          v-for="(item,index) in navList"
          :key="item.id"
          @click="changeNav(index)"
          :class="index == currentNav ? 'active' : $route.query.type == 'add' ? 'noclick' : ''">{{item}}</li>
        </template>
      </ul>
    </div> -->
    <div class="right">
      <!-- <leveSet v-if="currentNav == 0"></leveSet> -->
      <leveData v-if="currentNav == 1"></leveData>
    </div>

  </div>
</template>

<script>

import leveData from "./components/leveData";
import leveSet from "./components/leveSet";
import $Bus from "@/pages/projectImpl/js/eventBus"
export default {
  name:'LevelSeting',
  components: { leveData , leveSet },
  data () {
    return {
      navList:['关卡配置项','关卡数据'],
      currentNav:1,
    }
  },
  mounted(){
      const info = this.$store.getters["content/getTrainGameInfo"]();
    $Bus.$emit("pageHeaderTitle", this.$route.query.name + ' 关卡设置');
    const arr = ["首页","内容中心",{name: "训练游戏管理",path: info.fullPath || "/content/Traingame"},"训练游戏关卡设置"];
    $Bus.$emit("pageHeaderBreadcrumb", arr);
  },
  beforeDestroy(){
    $Bus.$emit("pageHeaderTitle", false);
  },
  methods: {
    changeNav(index){
      if(this.$route.query.type == 'add'){
        if(index == 0){
          this.currentNav = index
        }else{
          return
        }
      }else{
        this.currentNav = index
      }

    },
  }
}
</script>

<style scoped lang="less">
.LevelSeting{
  min-height: 400px;
  padding: 5px 0;
  display: flex;
  width: 100%;
  background-color: #fff;
  .left{
    width: 15%;
    border-right:1px solid #f2f2f2;
    ul{
      width: 100%;
      padding: 0;
      li{
        list-style: none;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active{
        background: rgb(230,247,255);
        color:#1890ff;
        border-right:4px solid #1890ff;
      }
      .noclick{
        cursor: not-allowed;
        background: #f4f4f4;
        opacity: 0.6;
      }
    }
  }
  .right{
    width: 100%;
    padding: 10px 20px;
  }
}
</style>
